import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { OnboardingClient } from '../shared/models/onboarding/onboarding-client';
import { StepChanged } from '../shared/models/onboarding/step-changed';
import { ClientListResponse } from '../shared/models/onboarding/client-list-response';
import { ClientNoteResponse } from '../shared/models/note/client-note-reponse';
import { ClientNotesResponse } from '../shared/models/note/client-notes-response';

@Injectable({
  providedIn: 'root',
})
export class WealthOnboardingService {
  env = environment;
  apiUrl = this.env.apiurl + 'platform/wealth/';
  constructor(private http: HttpClient) {}

  public GetWealthClients(onlyOnboardedCompleted: boolean): Observable<ClientListResponse> {
    return this.http.get<ClientListResponse>(`${this.apiUrl}clients/${onlyOnboardedCompleted}`);
  }

  public GetWealthClientInformation(clientId: number): Observable<OnboardingClient> {
    return this.http.get<OnboardingClient>(`${this.apiUrl}client/${clientId}`);
  }

  public UpdateStep(clientId: number, stepId: number, complete: boolean, updatedByUserId: number): Observable<StepChanged> {
    const changeStepRequest = {
      clientId: clientId,
      stepId: stepId,
      isComplete: complete,
      updatedByUserId: updatedByUserId,
    };
    return this.http.post<StepChanged>(`${this.apiUrl}step/update`, changeStepRequest);
  }

  public CompleteOnboarding(clientId: number, updatedByUserId: number): Observable<ClientNoteResponse> {
    const completeOnboardingRequest = {
      clientId: clientId,
      actionByUserId: updatedByUserId,
    };
    return this.http.post<ClientNoteResponse>(`${this.apiUrl}client/complete`, completeOnboardingRequest);
  }

  public BeginArbitrageOnboarding(clientId: number, updatedByUserId: number): Observable<ClientNoteResponse> {
    const request = {
      clientId: clientId,
      actionByUserId: updatedByUserId,
    };
    return this.http.post<ClientNoteResponse>(`${this.apiUrl}client/begin-arbitrage`, request);
  }

  public GetClientNotes(clientId: number): Observable<ClientNotesResponse> {
    return this.http.get<ClientNotesResponse>(`${this.apiUrl}client/${clientId}/notes`);
  }

  public CreateClientNote(clientId: number, note: string, updatedByUserId: number, noteType: number): Observable<ClientNoteResponse> {
    const changeStepRequest = {
      clientId: clientId,
      note: note,
      createdByUserId: updatedByUserId,
      noteType: noteType
    };
    return this.http.post<ClientNoteResponse>(`${this.apiUrl}client/create-note`, changeStepRequest);
  }

  public RestartVerification(clientId: number, updatedByUserId: number): Observable<ClientNoteResponse> {
    const request = {
      clientId: clientId,
      actionByUserId: updatedByUserId,
    };
    return this.http.post<ClientNoteResponse>(`${this.apiUrl}client/restart-verification`, request);
  }
}
